import { render, staticRenderFns } from "./novaContaBVTelecom.vue?vue&type=template&id=95419be2"
import script from "./novaContaBVTelecom.vue?vue&type=script&lang=js"
export * from "./novaContaBVTelecom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports